import styled from 'styled-components';

export const ThumbnailImageStyled = styled.img`
    display: block;
    max-width: 25rem;
    max-height: 25rem;
    width: auto;
    height: auto;
    border-radius: 0.8rem;
    cursor: pointer;
    box-shadow: 0 0.2rem 0.8rem ${({ theme }) => theme.colors.grey[400]};
`;
